import React, { useEffect } from "react";
import './DashboardView.css';
import Header from "../../components/Header/Header";
import Usermenu from "../../components/Usermenu/Usermenu";
import Sidebar from "../../components/Sidebar/Sidebar";
import Coursetable from "../../components/Coursetable/Coursetable";
import Footer from "../../components/Footer/Footer";
//import Copilot from "../../components/Copilot/Copilot";
import {NavLink, Outlet} from "react-router-dom";
import {Copilot} from "@iblai/ibl-web-react-common";
import CopilotLauncher from "../../components/CopilotLauncher/CopilotLauncher";
import CopilotCloser from "../../components/CopilotCloser/CopilotCloser";
import {defaultSPALogoData} from "../../hooks/helpers";
import logoImg from "../../assets/images/ibl-logos--copy_1.png";
import logoImg500 from "../../assets/images/ibl-logos--copy_1-p-500.png";
import logoImg800 from "../../assets/images/ibl-logos--copy_1-p-800.png";
import logoImg1080 from "../../assets/images/ibl-logos--copy_1-p-1080.png";
import logoImg1600 from "../../assets/images/ibl-logos--copy_1-p-1600.png";
import logoImg2000 from "../../assets/images/ibl-logos--copy_1-p-2000.png";


const DashboardView = () => {
  return (
      <span>
        <span className="af-view">
          <div className="body">
            <div className="w-layout-hflex fullpage-container">
              <div className="w-layout-vflex webpage-container no-padding-mobile">
                <Header></Header>
                <div className="mob_nav">
                  <div className="div-block">
                    <div className="mob_nav_trigger">
                      <div className="text-block-134 fa_icon"></div>
                    </div>
                    <NavLink
                        className="link-block-17 w-inline-block"
                        to="/"
                    >
                      <img
                          alt=""
                          className="image mob-logo"
                          loading="lazy"
                          sizes="(max-width: 479px) 100vw, (max-width: 767px) 34vw, (max-width: 991px) 202.1640625px, 100vw"
                          src={
                              defaultSPALogoData.logo || logoImg
                          }
                          srcSet={
                            defaultSPALogoData.logo
                                ? ''
                                : `${logoImg500} 500w, ${logoImg800} 800w, ${logoImg1080} 1080w, ${logoImg1600} 1600w, ${logoImg2000} 2000w`
                          }
                      />
                    </NavLink>
                    <div className="s-input">
                      <div className="form-block-4 w-form">
                        <form
                            className="form"
                            data-name="Email Form 4"
                            data-wf-element-id="568bac3c-da8e-db57-58f5-e56bfc43dece"
                            data-wf-page-id="657af3ad1367da03b3b125d5"
                            id="email-form-4"
                            method="get"
                            name="email-form-4"
                        >
                          <div className="div-block-245">
                            <input
                                className="text-field-2 w-input"
                                data-name="Name 2"
                                id="name-2"
                                maxLength={256}
                                name="name-2"
                                placeholder=""
                                type="text"
                            />
                            <div className="div-block-246">
                              <div className="text-block fa_icon mg"></div>
                            </div>
                          </div>
                        </form>
                        <div className="w-form-done">
                          <div>
                            Thank you! Your submission has been received!
                          </div>
                        </div>
                        <div className="w-form-fail">
                          <div>
                            Oops! Something went wrong while submitting the
                            form.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="left_mobile_nav_trigger">
                      <div className="text-block-134 fa_icon"></div>
                      <img
                          alt=""
                          className="image-4 hidden"
                          loading="lazy"
                          prop-attr-names="src"
                          prop-attr-value-src="userpic"
                          src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                      />
                      <div className="text-block fa_icon arrow no-mr hidden">
                        
                      </div>
                    </div>
                  </div>
                  <div className="div-block-355 left_menu_mob">
                    <div className="div-block-3">
                      <div className="div-block-2 mt-reduced">
                        <a className="ai-skills-btn w-inline-block" href="#">
                          <div className="text-block-130">AI Skills</div>
                        </a>
                      </div>
                      <div className="div-block-2">
                        <a className="link-block-18 w-inline-block" href="#">
                          <div className="text-block-130">Downloads</div>
                        </a>
                      </div>
                      <div className="div-block-2 hidden">
                        <div className="notifications_trigger">
                          <a
                              className="link-block-18 w-inline-block"
                              href="notifications.html"
                          >
                            <div className="text-block-130">Notifications</div>
                          </a>
                        </div>
                      </div>
                      <div className="div-block-2 nav-field hidden">
                        <div className="roles">
                          <img
                              alt=""
                              className="user-img nb"
                              loading="lazy"
                              src="images/setting_1setting.png"
                          />
                          <div className="text-block-130 sp">Roles</div>
                          <div className="text-block fa_icon arrow"></div>
                          <div className="div-block-164 profile">
                            <div className="div-block-165">
                              <div className="text-block-104">
                                Ashley Miller
                              </div>
                              <div className="text-block-104 em">
                                ashley@gmail.com
                              </div>
                            </div>
                            <a
                                className="link-block-11 w-inline-block"
                                href="#"
                            >
                              <div className="text-block-106">Overview</div>
                            </a>
                            <a
                                className="link-block-11 w-inline-block"
                                href="#"
                            >
                              <div className="text-block-106">Profile</div>
                            </a>
                            <a
                                className="link-block-11 w-inline-block"
                                href="#"
                            >
                              <div className="text-block-106">Log Out</div>
                            </a>
                          </div>
                          <div className="roles_popup">
                            <div className="div-block-195">
                              <a className="link-2" href="#">
                                Admin
                              </a>
                            </div>
                            <div className="div-block-195">
                              <a className="link-2" href="#">
                                Instructor
                              </a>
                            </div>
                            <div className="div-block-195 last">
                              <a className="link-2" href="#">
                                Editor
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Usermenu></Usermenu>
                    </div>
                  </div>
                </div>
                <div className="main">
                  <Sidebar></Sidebar>
                  <div className="mob_sidebar_overlay"></div>
                  <div className="main-content">
                    <Outlet />
                  </div>
                  <Footer></Footer>
                </div>
              </div>
              <Copilot isWhiteThemed={false} backgroundColor={"#282c34"}></Copilot>
              <CopilotCloser />
            </div>
            <CopilotLauncher />
          </div>
        </span>
      </span>
  );
};

export default DashboardView;
